export default __webpack_public_path__ + "static/media/MessinaSans-Light.20478d7e.woff2";